import { useEffect, useState, useContext, useRef } from "react";
import { createBrowserRouter, RouterProvider, useNavigate } from "react-router";
import axios from 'axios';

import { AppContext } from '../../../context.js';

import Helmet from "../../components/helmet.js";
import { Status, Button, Counter } from '../../components/component.js';

function PartnerCreate() {
  const context = useContext(AppContext);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  function createPartner() {
    let u = context.addSpiner();
    axios.post('/api/admin/partners/create', {
      title,
      description,
    }).then((response) => {
      navigate('/settings/partners');
    }).catch((e) => {
      context.addError(e);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }

  if (loading) {
    return <></>;
  }

  return (
    <>
      <Helmet title="Settings | Partner Create" />

      <div className="container-fluid">
        <div className="row mb-4">
          <div className="col-xs-12 col-lg-offset-3 col-lg-6">
            <div className="d-flex justify-content-between align-items-center">
              <div className="">
                <div className="typo-hero-small">Partner Create</div>
                <div className="typo-normal-175">Create a new partner organization and manage its details</div>
              </div>
              <div className="w-25 text-end">
                {/* <div className="item typo-normal-150 ms-2" onClick={() => navigate('/patient/create')}><FilePlus height={16} width={16} background={'none'} fill={'grey'} /> Create Patient</div> */}
              </div>
            </div>
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-xs-12 col-lg-offset-3 col-lg-6">

            <div className="card">
              <div className="card-header sm">
                <div className="typo-strong-200">General Information</div>
              </div>
              <div className="card-header sm">
                <div className="row">
                  <div className="col-xs-12 col-lg-4">
                    <div className="typo-strong-150">Title <span className="text-red">*</span></div>
                    <input type="text" placeholder="" value={title} onChange={(e) => setTitle(e.target.value)} className="input sm typo-normal-150 w-100" />
                  </div>
                  <div className="col-xs-12 col-lg-8">
                    <div className="typo-strong-150">Description</div>
                    <input type="text" placeholder="" value={description} onChange={(e) => setDescription(e.target.value)} className="input sm typo-normal-150 w-100" />
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-lg-offset-3 col-lg-6 text-end">
            <Button onClick={createPartner} color="blue" text="Create" />
          </div>
        </div>
      </div>
    </>
  );
}

export default PartnerCreate;